import { getOptimizedMagentoImageUrl } from "@ui/utils/getOptimizedMagentoImageUrl";

import { UiCheckIcon } from "@jti/brand-icons/ui-check";

import styles from "./CategoryCheckbox.module.scss";

export function CategoryCheckbox({
  label,
  checked,
  onChange,
  className,
  image,
  newBadge,
}: {
  label: string;
  checked: boolean;
  onChange: () => void;
  className: string;
  image: string;
  newBadge?: string;
}) {
  const optimizedImageUrl1x = image
    ? getOptimizedMagentoImageUrl({
        url: image,
        width: 69,
        height: 69,
        quality: 70,
      })
    : "";
  const optimizedImageUrl2x = image
    ? getOptimizedMagentoImageUrl({
        url: image,
        width: 138,
        height: 138,
        quality: 70,
      })
    : "";
  const optimizedImageSrcSet = optimizedImageUrl1x
    ? `${optimizedImageUrl1x} 1x${optimizedImageUrl2x ? `, ${optimizedImageUrl2x} 2x` : ""}`
    : undefined;

  return (
    <div className={className}>
      <label className={styles.label}>
        <input type="checkbox" checked={checked} onChange={onChange} className={styles.input} />
        <span className={styles.fakeInput}>
          <span className={styles.iconContent}>
            <UiCheckIcon height={10} width={10} />
          </span>
          {image && (
            <img
              className={styles.image}
              src={optimizedImageUrl1x}
              srcSet={optimizedImageSrcSet}
              alt=""
              fetchPriority="high"
              loading="eager"
              decoding="async"
            />
          )}
          {newBadge && (
            <div className={styles.badgeBlock}>
              <div className={styles.newBadge}>{newBadge}</div>
            </div>
          )}
        </span>
        <span className={styles.labelText}>{label}</span>
      </label>
    </div>
  );
}
